import React from 'react';
import { FontSizeOutlined } from '@ant-design/icons';
import { MediaQueryIcon } from 'admin/components/common/MediaQueryIcon';
import MediaQueryTooltip from 'admin/components/common/MediaQueryIcon/MediaQueryTooltip';
import type { StoryMediaPlatform } from 'types/story';
import css from './DesignPresetsEditor.scss';

export default function DesignPresetPlatformLabel({
	platform,
	defaultPlatform,
	label,
	referenceWidth,
}: {
	platform: 'base' | StoryMediaPlatform;
	defaultPlatform: StoryMediaPlatform;
	label: string;
	referenceWidth?: number;
}) {
	return (
		<span className={css.platformLabel}>
			{platform === 'base' ? (
				<FontSizeOutlined className={css.platformIcon} aria-hidden />
			) : (
				<MediaQueryTooltip mq={platform} isDefault={platform === defaultPlatform} placement="top">
					<MediaQueryIcon
						className={css.platformIcon}
						platform={platform}
						defaultPlatform={defaultPlatform}
						width={22}
						height={22}
					/>
				</MediaQueryTooltip>
			)}
			<span className={css.platformDetails}>
				<span>
					{label}
					{platform === defaultPlatform && <span className={css.baseBadge}> Base</span>}
				</span>
				{referenceWidth !== undefined ? <span className={css.platformWidth}>{referenceWidth}px</span> : null}
			</span>
		</span>
	);
}
